import React from 'react'
import './Leftbar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAdd, faBell, faCommentSms, faGear, faGears, faGift, faScaleBalanced} from '@fortawesome/free-solid-svg-icons'
import { faChartPie} from '@fortawesome/free-solid-svg-icons'
import { faLineChart} from '@fortawesome/free-solid-svg-icons'
import { faClipboardCheck} from '@fortawesome/free-solid-svg-icons'
import { faThLarge} from '@fortawesome/free-solid-svg-icons'
import { faQuestionCircle} from '@fortawesome/free-solid-svg-icons'
import { faArrowRightFromBracket} from '@fortawesome/free-solid-svg-icons'
//routers
import {useNavigate } from "react-router-dom";
import {Link } from "react-router-dom";
import Logo from '../Images/kuza-white.svg'
import {NavLink } from "react-router-dom";


import {app} from '../firebase.js'
import { getAuth, signOut } from "firebase/auth";
import { faGit } from '@fortawesome/free-brands-svg-icons'
import PlayIcon from '../Images/android.png'




function LeftBar() {

    let navigate = useNavigate();


    function logoutUser(){
        const auth = getAuth();
        signOut(auth).then(() => {
        // Sign-out successful.
            navigate("/")  
        }).catch((error) => {

        });
    }



  return (
    <div className='leftbar leftMenuBar'>

        <div className='menuContainer'>

            <div className='logocontainer'>
                <img src={Logo} alt=""  className='logo'/>
            </div>

            
            <div className='leftLinkCont d-flex align-items-center' >
                <NavLink to="/dashboard" className='leftNavLinks ' >
                    <FontAwesomeIcon icon={faThLarge} className="laftNavIcon"/>
                    Dashboard
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/reward-points" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faAdd} className="laftNavIcon"/>
                    Reward Points
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/reedem-points" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faGift} className="laftNavIcon"/>
                    Reedem Points
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/send-sms" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faCommentSms} className="laftNavIcon"/>
                    Send Promotional SMS
                </NavLink>
            </div>
            
            <hr />
            {/* <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/credit" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faCommentSms} className="laftNavIcon"/>
                    Kuza Credit
                </NavLink>
            </div> */}

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/settings" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faGear} className="laftNavIcon"/>
                    Settings
                </NavLink>
            </div>

        </div>

        <div className='footerMenu'>

            <a href='https://play.google.com/store/apps/details?id=com.kuza.points' className='playStoreIcon'>
                <img src={PlayIcon}/>
            </a>

            <div className='logoutMenu' onClick={logoutUser}>
                <div className='leftLinkCont d-flex align-items-center'>
                    <div  className='leftNavLinks logoutbtn'>
                        <FontAwesomeIcon icon={faArrowRightFromBracket} className="laftNavIcon"/>
                        Logout
                    </div>
                </div>
            </div>

        </div>




    
    </div>
  )
}

export default LeftBar 